import { useApi } from "hooks"
import { useMutation } from "@tanstack/react-query"
import { RECAPTCHA_TYPES } from "config/constants"

const useChangeMobileNumber = () => {

  const { apiFetch } = useApi()

  const url = `/auth/mobilenumber`;

  const changeMobileNumber = ({ mobileNumber }) => {
    return apiFetch({
      url,
      method: 'PUT',
      data: { mobileNumber },
      captcha: {
        type: RECAPTCHA_TYPES.v3,
        action: 'mobilenumber'
      }
    })
      .then( res => res.data)
  }

  const {
    mutate,
    ...rest
  } = useMutation(changeMobileNumber)

  return {
    changeMobileNumber: mutate,
    ...rest
  }

}

export default useChangeMobileNumber
